import { Component } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
declare var jQuery: any;
export interface PromptModel {
  title:string;
  message: string;
  question:string;
}

@Component({
  selector: 'prompt',
  template: `<div class="modal-dialog small-model">
                <div class="modal-content">
                   <div class="modal-header">
                     <button type="button" class="close" (click)="close()">&times;</button>
                     <h4 class="modal-title">{{title || 'Prompt'}}</h4>
                   </div>
                   <div class="modal-body">
                   <p class="modal-message linebreak" [innerHTML]="message"></p>
                   <hr class="hr-grey">
                   </div>

                   <div class="modal-footer">
                     <button type="button" class="btn btn-primary" (click)="clear()">{{question}}</button>
                     <button type="button" class="btn btn-default" (click)="cancel()" >Cancel</button>
                   </div>
                 </div>
                </div>`
})
export class ClearPromptComponent extends DialogComponent<PromptModel, string> implements PromptModel {
  title: string;
  message: string;
  question: string;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  clear() {
    this.result = "0";
    this.close();
  }

  cancel() {
    this.close();
  }

}
